/**
 * 字典接口
 */
import Axios from '@/components/api/axios.js'

export default {
	/**
	 * 获取字典树
	 */
	getEnumTree: (success, failure) => {
		Axios.post('/enum/getEnumTree.do', {}, success, failure);
	},
	addEnum: (enumCode, enumName, linq, success, failure) => {
		Axios.post('/enum/addEnum.do', {
			enumCode,
			enumName,
			linq
		}, success, failure);
	},
	deleteEnum: (enumCode, success, failure) => {
		Axios.post('/enum/deleteEnum.do', {
			enumCode
		}, success, failure);
	},
	updateEnum: (enumCode, enumName, linq, success, failure) => {
		Axios.post('/enum/updateEnum.do', {
			enumCode,
			enumName,
			linq
		}, success, failure);
	},
	addEnumItem: (enumCode, itemText, itemValue, sort, success, failure) => {
		Axios.post('/enum/addEnumItem.do', {
			enumCode,
			itemText,
			itemValue,
			sort
		}, success, failure);
	},
	updateEnumItem: (pkid, itemText, itemValue, sort, success, failure) => {
		Axios.post('/enum/updateEnumItem.do', {
			pkid,
			itemText,
			itemValue,
			sort
		}, success, failure);
	},
	deleteEnumItem: (pkid, success, failure) => {
		Axios.post('/enum/deleteEnumItem.do', {
			pkid,
		}, success, failure);
	},

}